/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloneInitiativeRequest
 */
export interface CloneInitiativeRequest {
    /**
     * 
     * @type {string}
     * @memberof CloneInitiativeRequest
     */
    newName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CloneInitiativeRequest
     */
    includeCostItems?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CloneInitiativeRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the CloneInitiativeRequest interface.
 */
export function instanceOfCloneInitiativeRequest(value: object): value is CloneInitiativeRequest {
    return true;
}

export function CloneInitiativeRequestFromJSON(json: any): CloneInitiativeRequest {
    return CloneInitiativeRequestFromJSONTyped(json, false);
}

export function CloneInitiativeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloneInitiativeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newName': json['newName'] == null ? undefined : json['newName'],
        'includeCostItems': json['includeCostItems'] == null ? undefined : json['includeCostItems'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function CloneInitiativeRequestToJSON(json: any): CloneInitiativeRequest {
    return CloneInitiativeRequestToJSONTyped(json, false);
}

export function CloneInitiativeRequestToJSONTyped(value?: CloneInitiativeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newName': value['newName'],
        'includeCostItems': value['includeCostItems'],
        'effectTenantId': value['effectTenantId'],
    };
}

